var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMediaConvert = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88254 0.0067122C5.83085 0.0169361 4.51997 0.835177 2.96947 1.82506C0.452338 3.43209 0.141016 3.64406 0.0628799 3.80416C-0.015773 3.96539 -0.0179343 4.001 0.0413138 4.15724C0.102206 4.31757 0.327687 4.47163 2.96796 6.15669C5.3884 7.70139 5.855 7.98239 6 7.98239C6.145 7.98239 6.6116 7.70139 9.03204 6.15669C11.6723 4.47163 11.8978 4.31757 11.9587 4.15724C12.0179 4.001 12.0158 3.96539 11.9371 3.80416C11.8589 3.64387 11.5501 3.43393 9.03053 1.82869C7.48003 0.840831 6.15857 0.0225898 6.09397 0.01034C6.02937 -0.00186269 5.93422 -0.00351169 5.88254 0.0067122ZM0.927263 7.1494C0.214313 7.60848 0.0980247 7.7005 0.0410318 7.8507C-0.0178874 8.00594 -0.0156321 8.04199 0.0628799 8.20298C0.141063 8.36321 0.452621 8.57514 2.98572 10.1912C5.44008 11.7569 5.84514 12 6 12C6.15486 12 6.55992 11.7569 9.01428 10.1912C11.5474 8.57514 11.8589 8.36321 11.9371 8.20298C12.0157 8.04199 12.0179 8.00594 11.959 7.85065C11.9017 7.69979 11.7868 7.60957 11.0613 7.14558L10.2293 6.61347L8.47879 7.73079C7.51597 8.34531 6.62763 8.88652 6.50457 8.93349C6.21716 9.04322 5.78284 9.04322 5.49543 8.93349C5.37237 8.88652 4.48492 8.34588 3.52328 7.73207C2.56164 7.11826 1.76876 6.61714 1.76134 6.61851C1.75392 6.61988 1.3786 6.85875 0.927263 7.1494Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMediaConvert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-media-convert.1a4ae1c2d4e3e97151b4bf7fc267e2a8.svg";